import * as R from "ramda";
import { Link } from "react-router-dom";

import { Menu, Dropdown, Icon } from "antd";
import { css } from "glamor";

const styles = {
    userIcon: css({
        fontSize: "16px !important",
    }),
    menu: css({
        "& i": {
            color: "#1b75bc",
        },
        "& span": {
            color: "#1b75bc",
        },
        display: "table", //FIXME - QUICK HACK FOR: T7990
    }),
    menuItem: css({
        textAlign: "center",
    }),
    selectedMenuItem: css({
        backgroundColor: "#1b75bc",
        "& span": {
            color: "#ffffff !important",
        },
        "& i": {
            color: "#ffffff",
        },
        ":hover": {
            // using important there as ant design
            // adds a class on hover which has
            // greater specificity
            backgroundColor: "#1b75bc !important",
        },
        ":after": {
            content: " ",
            position: "absolute",
            width: "100%",
            height: "2px",
            bottom: "-4px",
            left: "0",
            backgroundColor: "#1b75bc",
        },
    }),
};

export default ({
    auth,
    config,
    menuItems,
    currentLocation,
    userlist,
    switchUserHandler,
    switchUserBackHandler,
    ...otherProps
}) => {
    const getHooks = R.pipe(
        R.propOr([], "hooks"),
        R.sortBy(R.prop("priority"))
    );

    const selectedItemKeys = menuItems
        .filter(
            item => currentLocation && currentLocation.startsWith(item.link)
        )
        .map(item => item.label);

    const getMenuItemStyles = item =>
        selectedItemKeys.includes(item)
            ? { ...styles.menuItem, ...styles.selectedMenuItem }
            : styles.menuItem;

    return (
        <Menu
            {...otherProps}
            mode="horizontal"
            selectedKeys={selectedItemKeys}
            {...styles.menu}
        >
            {menuItems.map(({ atId, icon, label, link }) => (
                <Menu.Item key={label} {...getMenuItemStyles(label)}>
                    <Link data-at-id={atId} to={link}>
                        {icon && <Icon type={icon} />}
                        <span>{label}</span>
                    </Link>
                </Menu.Item>
            ))}

            <Menu.Item>
                <Dropdown
                    overlay={
                        <Menu>
                            {auth.is_admin && !auth.switched_from && (
                                <Menu.SubMenu
                                    title={
                                        <span>
                                            Switch user
                                            <sup>admin only</sup>
                                        </span>
                                    }
                                >
                                    {R.map(
                                        user => (
                                            <Menu.Item
                                                key={user.id}
                                                onClick={() =>
                                                    switchUserHandler(user.id)
                                                }
                                            >
                                                {user.username}
                                            </Menu.Item>
                                        ),
                                        R.sortBy(R.prop("username"))(
                                            userlist.users
                                        )
                                    )}
                                </Menu.SubMenu>
                            )}
                            {auth.switched_from && (
                                <Menu.Item onClick={switchUserBackHandler}>
                                    Switch back to admin
                                </Menu.Item>
                            )}
                            {R.map(
                                hook => (
                                    <Menu.Item key={hook.label}>
                                        <a href={hook.link}>{hook.label}</a>
                                    </Menu.Item>
                                ),
                                getHooks(config)
                            )}
                            {auth.is_admin && (
                                <Menu.Item>
                                    <a href="/request-portal/">
                                        Go to Request Portal
                                    </a>
                                </Menu.Item>
                            )}
                            <Menu.Item>
                                <Link to="/logout/">
                                    <Icon type="logout" /> Logout
                                </Link>
                            </Menu.Item>
                        </Menu>
                    }
                >
                    <div>
                        <Icon className={`${styles.userIcon}`} type="user" />
                        <span to="#">{auth.displayName}</span>
                    </div>
                </Dropdown>
            </Menu.Item>
        </Menu>
    );
};
